"use client";

import Image from "next/image";
import dynamic from "next/dynamic";
import { useState } from "react";
import "yet-another-react-lightbox/styles.css";

const Lightbox = dynamic(() => import("yet-another-react-lightbox"), {
  ssr: false,
});

type Img = { src: string; alt: string };

export default function SingleRoomTopGallery({
  images = [],
}: {
  images?: Img[];
}) {
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);

  // No images → render nothing
  if (!images || images.length === 0) return null;

  return (
    <>
      <div className="md:grid gap-4 flex flex-col md:grid-cols-4 grid-cols-none reveal-stagger">
        {/* Left: big image */}
        {images[0] && (
          <button
            type="button"
            className="md:col-span-2 w-full cursor-pointer text-left reveal-item"
            onClick={() => {
              setIndex(0);
              setOpen(true);
            }}
          >
            <Image
              src={images[0].src}
              alt={images[0].alt}
              width={1200}
              height={800}
              priority
              className="w-full h-[400px] md:h-[500px] object-cover transition-transform duration-300 hover:scale-[1.01]"
            />
          </button>
        )}

        {/* Right: up to 4 small images */}
        <div className="grid grid-cols-2 gap-4 reveal-stagger col-span-2">
          {images.slice(1, 5).map((img, i) => (
            <button
              type="button"
              key={i + 1}
              className="relative h-[180px] md:h-[240px] reveal-item cursor-pointer"
              onClick={() => {
                setIndex(i + 1);
                setOpen(true);
              }}
            >
              <Image
                src={img.src}
                alt={img.alt}
                fill
                sizes="(max-width: 768px) 50vw, 33vw"
                className="object-cover transition-transform duration-300 hover:scale-[1.01]"
              />
            </button>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      <Lightbox
        open={open}
        close={() => setOpen(false)}
        index={index}
        slides={images.map((i) => ({ src: i.src, alt: i.alt }))}
        controller={{ closeOnBackdropClick: true }}
      />
    </>
  );
}
